import { Component, Input } from '@angular/core';
import { AdditionalSectionCard } from 'src/app/model/card/additional-section-card';

@Component({
  selector: 'app-additional-section-card',
  templateUrl: './additional-section-card.component.html',
  styleUrls: ['./additional-section-card.component.scss']
})
export class AdditionalSectionCardComponent {
  @Input() additionalSectionCards: AdditionalSectionCard[] = [];
  @Input() headImage: string = '';
  @Input() title: string = '';
  @Input() seeAllNews: string = '';
  @Input() newsUrl: string = '';
}
